<script setup>
import { ACCOUNT_NAV_ITEMS } from '@/constants/AccountConstants.js'
import { translate } from '@/plugins/i18n.js'
import { computed } from 'vue'

const props = defineProps({
  action: {
    type: String,
    default: ''
  }
})

const currentItem = computed(() => {
  return ACCOUNT_NAV_ITEMS.find((item) => item.action === props.action)
})

const title = computed(() => {
  return currentItem.value ? translate(currentItem.value.labelKey) : ''
})
</script>

<template>
  <VSheet class="pa-6" v-if="currentItem">
    <h1 class="font-size-xl font-weight-bold">{{ title }}</h1>
    <p class="mt-3 c-gray">
      {{ translate(currentItem.descriptionKey) }}
    </p>
  </VSheet>
</template>
